import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Link } from "components";

interface Header {
    title: string;
    redirectTo?: string;
    btnTitle?: string;
}

export const Header: React.FC<Header> = ({ title, redirectTo, btnTitle, children }) => {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} p={2}>
            <Typography variant="h5">{title}</Typography>
            {redirectTo && btnTitle && (
                <Link to={redirectTo}>
                    <Button disableRipple variant="contained" color="primary">
                        {btnTitle}
                    </Button>
                </Link>
            )}
            {children}
        </Box>
    );
};
